import styled from 'styled-components';

const SForm = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export default SForm;
